var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{staticClass:"bg",attrs:{"fluid":"","grid-list-md":"","align-center":""}},[_c('ComponentAdminLogin')],1)}
var staticRenderFns = []

export { render, staticRenderFns }